import "./ROEWebDataTableStyle.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import React, { useCallback, useEffect, useRef, useState } from "react";

import ArchiveIcon from "@mui/icons-material/Archive";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { EnhancedButtonPrimeReact } from "../../EnhancedButtonPrimeReact";
import {  EnhancedButtonPrimeReactSeverity, formatAmountCommaSeperator, getValueByFieldPath } from "../../../common/Common";
import { IAppState } from "../../../store/reducers";
import { InputText } from "primereact/inputtext";
import { RequestParams } from "@websential/cosmic-v20";
import { useSelector } from "react-redux";
import { useTheme } from "@mui/material";
import { InputNumber } from "primereact/inputnumber";

export interface IROEWebDataTable {
	rows: any;
	columns?: any;
	onRowDeleteClicked?: (params: any) => void;
	onRowEditClicked?: (params: any) => void;
	onRowArchiveClicked?: () => void;
	isLoading?: any;
	onRequestParamsChange?: (params: RequestParams) => void;
	initialPageSize?: number | undefined;
	initialPage?: number;
	totalRecords?: number;
	rowsPerPageOptions?: number[];
	tableScrollHeight?: string;
	showHeaderColumns?: boolean;
	showDeleteIcon?: boolean;
	showArchiveIcon?: boolean;
	showPaginator?: boolean;
	showChecboxColumn: boolean;
	selectedRowsValues?: any;

}

export const ROEWebDataTable: React.FC<IROEWebDataTable> = ({
	rows,
	columns,
	onRowDeleteClicked,
	onRowEditClicked,
	onRowArchiveClicked,
	isLoading,
	onRequestParamsChange,
	initialPageSize = 10,
	initialPage = 0,
	totalRecords,
	rowsPerPageOptions,
	tableScrollHeight,
	showHeaderColumns = false,
	showDeleteIcon = true,
	showArchiveIcon = true,
	showPaginator = true,
	showChecboxColumn,
	selectedRowsValues,
}) => {
	const isInitialRequest = useRef(true);
	const [loading, setLoading] = useState(false);
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const [itemSearch, setItemSearch] = useState("");
	const [requestParams, setRequestParams] = useState<any>({
		first: initialPage,
		rows: initialPageSize,
		page: initialPage,
		sortField: null,
		sortOrder: "asc",
		searchQuery: "",
		filters: {
			name: { value: "", matchMode: "contains" },
			"country.name": { value: "", matchMode: "contains" },
			company: { value: "", matchMode: "contains" },
			"representative.name": { value: "", matchMode: "contains" },
		},
	});

	const [selectedItems, setSelectedItems] = useState<any>([]);
	const [selectedItemsIds, setSelectedItemsIds] = useState<any>([]);
	const [activeRowIndex, setActiveRowIndex] = useState<number | null>(null);

	// const ArchiveIcon = () => (
	// 	<svg
	// 		xmlns="http://www.w3.org/2000/svg"
	// 		width="16"
	// 		height="16"
	// 		fill="currentColor"
	// 		viewBox="0 0 16 16"
	// 	>
	// 		<path d="M2.5 1a1 1 0 0 0-1 1v2a1 1 0 0 0 .293.707L3 5.914V14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5.914l1.207-1.207A1 1 0 0 0 14.5 4V2a1 1 0 0 0-1-1h-11zm1 6a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8A.5.5 0 0 1 3.5 7z" />
	// 	</svg>
	// );
	const delEditArchive = (params: any) => {
		return (
			<>
				{/* <EnhancedButtonPrimeReact
					icon={"pi pi-user-edit"}
					onClickHandler={() => onRowEditClicked && onRowEditClicked(params)}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
					className="p-button-rounded p-button-text w-2rem h-2rem"
					rounded
				/> */}
				{showArchiveIcon && (
					<Button
						icon={<ArchiveIcon />}
						// icon={<ArchiveOutlinedIcon/>}
						onClick={onRowArchiveClicked}
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
						className="p-button-rounded p-button-text w-2rem h-2rem ml-2"
						style={{ fontSize: "16px", color: "grey" }}
						rounded
					/>
				)}
				{showDeleteIcon && (
					<EnhancedButtonPrimeReact
						// icon="pi pi-trash"
						icon="pi pi-times"
						onClickHandler={() =>
							onRowDeleteClicked && onRowDeleteClicked(params)
						}
						severity={EnhancedButtonPrimeReactSeverity.Danger}
						className="p-button-rounded p-button-text w-2rem h-2rem ml-2"
						rounded
					/>
				)}
			</>
		);
	};
	const renderHeader = () => {
		return (
			<div
				style={{
					display: "flex",
					alignItems: "center",
				}}
			>
				<span
					className="p-input-icon-left w-full"
					style={{ display: "flex", height: "37px" }}
				>
					<i className="pi pi-search" />
					<InputText
						value={itemSearch}
						onChange={(e) => setItemSearch(e.target.value)}
						placeholder={"Search..."}
						className="w-full"
						style={{ borderRadius: "2px 2px 2px 2px" }}
					/>
				</span>
			</div>
		);
	};
	const headerSearch = renderHeader();
	function search(_row: any) {
		return (
			rows &&
			rows.filter(
				(rows: any) =>
					rows.label.props.children
						.toLowerCase()
						.indexOf(itemSearch.toLowerCase()) > -1
			)
		);
	}

	const onPage = (event: any) => {
		// setRequestParams(event);
		setLoading(true);
		//imitate delay of a backend call
		setTimeout(() => {
			setRequestParams({
				...event,
				searchQuery: itemSearch,
			});
			setLoading(false);
		}, 1000);
	};

	useEffect(() => {
		// if the results fetcher was passed, we can use it to fetch the results.
		if (onRequestParamsChange) {
			// skip the first initial call
			if (isInitialRequest.current === true) {

				isInitialRequest.current = false;
			} else {

				onRequestParamsChange(requestParams);
			}
		}
	}, [onRequestParamsChange, requestParams]);


	const onSelectionModelChange = useCallback(
		(items: any) => {
			let selectedItemsIds = items.value.map((item: any) => item.id);
			// setSelectedItems(selectedItemsIds);
			// Check for deleted items and remove them from selectedItems
			const updatedSelectedItems = items.value.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
			setSelectedItems(updatedSelectedItems);
			setSelectedItemsIds(selectedItemsIds);
			if (selectedRowsValues) {
				if (items.value.length > 0) {
					const selectedRowData = rows.filter((row: any) => {
						return items.value.includes(row);
					});

					selectedRowsValues(selectedRowData);
				} else {
					selectedRowsValues(items.value);

				}
			}
		},
		[rows, selectedRowsValues, selectedItems]
	);


	// useEffect(() => {
	// 	if (selectedItems && selectedItems.length > 0) {
	// 		// Check if all selected items exist in rows
	// 		const allExist = selectedItems.every((selectedItem: any) =>
	// 			rows?.some((row: any) => row.employeeId === selectedItem.employeeId)
	// 		);
	// 		if (!allExist) {
	// 			// ❌ One or more items removed → reset to initial state
	// 			setSelectedItems([]);
	// 			setSelectedItemsIds([]);
	// 			if (selectedRowsValues) selectedRowsValues([]);
	// 		}
	// 	}
	// }, [rows]);

	// const getRowClassName = (data: any, options: any) => {
	// 	return data.id === activeRowIndex ? "highlighted-row" : ""; 
	// };

		const getRowClassName = (data: any, options: any) => {
		return data.status === "Generaeted"
			? "file-generated"
			: data.status === "Ready"
			? "ready-to-generate-roe-file"
			: data.status === "Issued"
			? "submitted"
			: "";
	};


	const columnsBody = (rowData: any, row: any, x: any) => {
		const value = getValueByFieldPath(rowData, x.field);
	

		return (
			<span
				style={{ cursor: "pointer", display: "block" }}
				//   onClick={() => setActiveRowIndex(rowData)}
				onClick={() => {
					// setActiveRowIndex(rowData.id);
					onSelectionModelChange({
						value: [rowData],
					});
				}}
			>
				{value}
			</span>
		);
	};


	return (
		<>
			<DataTable
				value={rows && search(rows)}
				dataKey="value"
				selection={selectedItems}
				responsiveLayout="scroll"
				lazy
				paginator={showPaginator ? true : false}
				first={requestParams.first}
				rows={requestParams.rows}
				totalRecords={totalRecords}
				onPage={onPage}
				onSelectionChange={onSelectionModelChange}
				selectionMode={"multiple"}
				rowClassName={getRowClassName}
				rowsPerPageOptions={rowsPerPageOptions}
				paginatorTemplate=" PrevPageLink PageLinks NextPageLink  CurrentPageReport RowsPerPageDropdown"
				currentPageReportTemplate={`Showing {first} to {last} of ${totalRecords} Items`}
				scrollable
				scrollHeight={tableScrollHeight ? tableScrollHeight : "75vh"}
				loading={isLoading}
				header={headerSearch}
				emptyMessage="No Record found."
				className={`${showHeaderColumns ? "ROEWebDataTableStyleWithHeaderColumns" : "ROEWebDataTableStyle"
					}`}
				style={{
					position: "sticky",
					top: subMenuVisibility ? "170px" : "128px",
				}}
			>
				{columns && rows && rows.length > 0 && (
					<Column
						selectionMode="multiple"
						hidden={!showChecboxColumn}
						frozen
						resizeable={false}
						style={{ width: "36px", textAlign: "center" }}
						field="selection"
						columnKey="selection"
						className="selectionHeader"
						headerClassName="selectionHeader"
					></Column>
				)}

				{columns &&
					columns.map((x: any, index: any) => (
						<Column key={index} field={x.field} header={x.headerName} align={x.align}
							bodyClassName={(rowData: any, row: any) =>
								rowData.status === "Generated"
									? "file-generated"
									: rowData.status === "Ready"
										? "ready-to-generate-roe-file"
										: rowData.status === "Issued"
											? "submitted"
											: ""
							}
							body={(rowData: any, row: any) =>
								columnsBody(rowData, row, x)
							}
						/>
					))}
			</DataTable>
		</>
	);
};
